// Профили игроков рейтинга: свой (вкладка «Партии» окна профиля) и чужой (тап по строке таблицы). С сервера
// (GET api/player) — места в номинациях и последние поражения; поражение открывается в плеере (replay.ts).
import type { PlayerProfile } from '../types.ts';
import { clientId } from './outbox.ts';
import * as OV from './overlays.ts';
import type { PlayerLoad } from './overlays.ts';
import { openModal, repaintModal, modalOpen, currentModal } from './store.ts';

function isPlayerProfile(x: unknown): x is PlayerProfile {
  if (!x || typeof x !== 'object') return false;
  const o = x as Partial<PlayerProfile>;
  return Array.isArray(o.boards) && Array.isArray(o.losses);
}

/** Чей профиль в загрузке (запрос) и чем перерисовать окно — для листания поражений */
const sources = new WeakMap<PlayerLoad, { q: string; repaint: () => void }>();

/**
 * Загрузить профиль в load: q — «id=…» (чужой) или пусто (свой, по id клиента); offset — с какого поражения
 * страница; repaint — когда пришёл ответ. Прежние данные видны, пока идёт загрузка (листание).
 */
export async function loadPlayer(load: PlayerLoad, q: string, repaint: () => void, offset = 0): Promise<void> {
  sources.set(load, { q, repaint });
  load.loading = true;
  load.error = false;
  repaint();
  try {
    const r = await fetch(`api/player?${q ? q + '&' : ''}offset=${offset}&client=${encodeURIComponent(clientId())}`);
    const j: unknown = r.ok ? await r.json() : null;
    if (!isPlayerProfile(j)) throw new Error('bad player');
    load.data = j;
  } catch {
    load.error = true;
  } finally {
    load.loading = false;
    repaint();
  }
}

/** Другая страница поражений того же профиля; пришла — окно прокручивается к началу списка (листают снизу) */
export function pagePlayer(load: PlayerLoad, offset: number): void {
  const src = sources.get(load);
  if (!src || load.loading) return;
  void loadPlayer(load, src.q, src.repaint, offset).then(() => {
    if (!load.error) document.getElementById('losses-head')?.scrollIntoView({ block: 'start' });
  });
}

/** Открытый чужой профиль */
export const otherPlayer: PlayerLoad = { data: null, loading: false, error: false };

/** Профиль игрока по публичному id (тап по строке рейтинга) */
export function openPlayer(id: string): void {
  Object.assign(otherPlayer, { data: null, loading: true, error: false });
  const build = (): ReturnType<typeof OV.playerV> => OV.playerV(otherPlayer);
  openModal(build);
  void loadPlayer(otherPlayer, `id=${encodeURIComponent(id)}`, () => { if (modalOpen() && currentModal() === build) repaintModal(); });
}
